<template>
  <zyc-content class="jssc-qyzl-content-list-fx" :id="qid">
    <zyc-title :rightItem="isRightBut?titleRightBtn:[]">{{ title }}</zyc-title>
    <div :id="id" :style="{ width:'calc(100%)', height: 'calc(100% - 60px)', 'margin-top':'10px','position':'relative','z-index':2000}"></div>
    <div v-if="isTable" style="width: 100%; height: calc(100% - 55px); overflow-y: scroll; position: absolute; top: 55px; left: 0;z-index:2001">
      <table class="zyc-table" v-html="tableHtml">
      </table>
    </div>
    <template v-if="!isLoading">
      <div :class="data != null && data.length > 0 ? 'jssc-qyzl-content-list-fx-empty': 'jssc-qyzl-content-list-fx-empty empty'">
        <span>
          <img src="data:image/png;base64,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" ondragstart="return false">
          暂无数据
        </span>
      </div>
    </template>
  </zyc-content>
</template>
<script>
  import * as echarts from 'echarts';
  import theme from "./config/myTheme.json"
  echarts.registerTheme('mytheme', theme)
  import optionConfig from './config/optionConfig'
  import screenfull from "screenfull/dist/screenfull"
  /**
  * 图表模块
  */
  export default {
    name: 'zycChartModule',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      type: {
        type: String,
        default: 'pie1'
      },
      title: {
        type: String,
        default: ''
      },
      isRightBut: {
        type: Boolean,
        default: true
      },
      ready: {
        type: Function,
        default: () => { }
      }
    },
    model: {
    },
    watch: {
      data: {
        handler: function (newVal, oldVal) {
          if (this.myChart) {
            this.showLoad()
            this.initData()
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        id: Math.random().toString(36).slice(2),
        qid: Math.random().toString(36).slice(2),
        titleRightBtn: [
          {
            icon: 'icon-form',
            title: '表格',
            onclick: this.dataView
          },
          {
            icon: 'icon-data',
            title: '图表',
            onclick: this.chartView
          },
          {
            icon: 'icon-full-screen',
            title: '全屏',
            onclick: this.fullScreen
          },
          {
            icon: 'icon-download',
            title: '下载',
            onclick: this.download
          }
        ],
        myChart: null,
        fontSizebl: 1,
        isFullScreens: false,
        isTable: false,
        total: 0,
        tableHtml: '',
        divHeight: 0,
        isLoading: false
      }
    },
    mounted() {
    },
    beforeDestroy() {
      if (!this.myChart) {
        return
      }
      this.myChart.dispose()
      this.myChart = null
      window.removeEventListener('resize', this.onresize)
    },
    created() {
      this.onresize()
      window.addEventListener('resize', this.onresize)
      this.$nextTick(() => {
        this.init()
      })
    },
    methods: {
      onresize(event) {
        this.$nextTick(() => {
          if (!document.webkitIsFullScreen) {
            $('#' + this.qid).removeClass('zyc-bg')
            this.isFullScreens = false
            this.titleRightBtn[2].title = '全屏'
            this.titleRightBtn[2].icon = 'icon-full-screen'
            this.fontSizebl = 1
          }
          //if (this.isFullScreen()) {
          //  if (this.isFullScreens) {
          //    this.fontSizebl = 5
          //  } else {
          //    this.fontSizebl = 1
          //  }
          //} else {
          //  this.fontSizebl = 1
          //}
          //if (!this.isTable) {
          //  if (this.myChart) {
          //    this.initData()
          //    this.myChart.resize()
          //  }
          //}
          if (this.myChart) {
            this.initData()
            this.myChart.resize()
          }
        })
      },
      isFullScreen() {
        return !!(document.webkitIsFullScreen);
      },
      init: function () {
        if (!this.myChart) {
          this.myChart = echarts.init(document.getElementById(this.id));
          this.myChart.clear();
          this.isLoading = true
          this.myChart.showLoading({
            text: 'loading...',
            color: '#23CEFD',
            textColor: '#23CEFD',
            maskColor: 'rgba(0, 0, 0, .1)',
            zlevel: 0,
          })
        }
        this.ready(this)
      },
      initData: function () {
        this.$nextTick(() => {
          this.isTable = false
          if (this.data.length > 0) {
            this.total = 0
            this.data.forEach(el => {
              this.total += parseInt(el.value)
            })
            var option = optionConfig.chartsOption[this.type](this.fontSizebl, this.total, this.data)
            this.tableHtml = optionConfig.tableOption[this.type](this.data, this.total)

            this.myChart.setOption(option, true)
          }
          this.isLoading = false
          this.myChart.hideLoading()
        })
      },
      dataView: function () {
        //console.log('表格')
        this.myChart.clear()
        this.tableHtml = optionConfig.tableOption[this.type](this.data, this.total)
        this.isTable = true
      },
      chartView: function () {
        //console.log('图表')
        this.isTable = false
        this.$nextTick(() => {
          this.initData()
        })
      },
      fullScreen: function () {
        //console.log('全屏')
        const el = document.getElementById(this.qid)
        var that = this
        $(el).addClass('zyc-bg')
        if (this.isTable) {
          this.chartView()
          setTimeout(function () {
            if (el.requestFullscreen) {
              el.requestFullscreen();
            } else if (el.msRequestFullscreen) {
              el.msRequestFullscreen();
            } else if (el.webkitRequestFullScreen) {
              el.webkitRequestFullScreen();
            } else if (el.mozRequestFullScreen) {
              el.mozRequestFullScreen();
            } else {
            }
            that.$nextTick(() => {
              that.isFullScreens = true
              that.fontSizebl = 5
              that.initData()
              that.myChart.resize()
            })
          }, 1000)
        } else {
          if (this.isFullScreens) {
            this.titleRightBtn[2].title = '全屏'
            this.titleRightBtn[2].icon = 'icon-full-screen'
            if (el.exitFullscreen) {
              el.exitFullscreen()
            } else if (el.webkitCancelFullScreen) {
              el.webkitCancelFullScreen()
            } else if (el.mozCancelFullScreen) {
              el.mozCancelFullScreen()
            } else if (el.msExitFullscreen) {
              el.msExitFullscreen()
            }
            $('#' + this.qid).removeClass('zyc-bg')
            screenfull.toggle()
            this.isFullScreens = false
            this.fontSizebl = 1
          } else {
            this.titleRightBtn[2].title = '退出全屏'
            this.titleRightBtn[2].icon = 'icon-exit-full-screen'
            if (el.requestFullscreen) {
              el.requestFullscreen();
            } else if (el.msRequestFullscreen) {
              el.msRequestFullscreen();
            } else if (el.webkitRequestFullScreen) {
              el.webkitRequestFullScreen();
            } else if (el.mozRequestFullScreen) {
              el.mozRequestFullScreen();
            } else {
            }
            this.isFullScreens = true
            this.fontSizebl = 5
          }
          setTimeout(function () {
            that.$nextTick(() => {
              that.initData()
              that.myChart.resize()
            })
          }, 100)
        }
      },
      downloadUrlFile(url, fileName) {
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = url
        if (fileName) {
          a.download = fileName
        }
        a.click()
        window.URL.revokeObjectURL(url)
      },
      download: function () {
        //console.log('下载')
        if (this.isTable) {
          this.chartView()
        }
        var that = this
        setTimeout(function () {
          const chartImgUrl = that.myChart.getDataURL({
            pixelRatio: 2,
            backgroundColor: '#083366'
          })
          that.downloadUrlFile(chartImgUrl, that.title)
        }, 1000)
      },
      chartLoad: function () {
        // echart 渲染动画结束后执行
        //this.myChart.hideLoading()
        //this.isLoading = false
        console.log('chartLoad')
      },
      showLoad: function () {
        if (!this.myChart) {
          this.myChart = echarts.init(document.getElementById(this.id));
          this.initData()
        }
        this.myChart.clear()

      },
      hideLoad: function () {

        this.initData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/echarts/chartModule.vue